import React from 'react';
import PropTypes from 'prop-types';

const FocusableInputArea = ({ children, className, height }) => (
  <div
    className={`d-flex flex-row align-items-center justify-content-center cursor-pointer ${className}`}
    role="button"
    tabIndex={0}
    onKeyUp={() => {}}
    onClick={(e) => {
      if (e.target.closest('.d-flex').querySelector('.form-control')) {
        e.target.closest('.d-flex').querySelector('.form-control').focus();
      }
    }}
    style={{ height }}>
    {children}
  </div>
);

export default FocusableInputArea;

FocusableInputArea.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  className: PropTypes.string,
  height: PropTypes.string,
};

FocusableInputArea.defaultProps = {
  className: 'mt-1',
  height: '3rem',
};
